<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="records.length">
          <div class="text-right">
            <LoadingButton
              title="Сохранить"
              type="button"
              className="btn btn-success btn-sm"
              :onClick="() => saveSelected()"
              :loading="loadingBtn"
              color="white"
            />
          </div>
          <table class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th>#</th>
              <th></th>
              <th>ID</th>
              <th>Препарат</th>
              <th>Цена</th>
              <th>Остаток</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, i) in records" :key="i">
              <td>{{ i + 1 }}</td>
              <td>
                <input type="checkbox" v-model="selected[d.id]"/>
              </td>
              <td>{{ d.id }}</td>
              <td>{{ d.title }}</td>
              <td>{{ d.price }}</td>
              <td>{{ d.in_store }}</td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      loadingBtn: false,
      records: [],
      selected: {},
    }
  },
  created() {
    this.getDrugs();
  },
  methods: {
    async saveSelected() {
      this.loadingBtn = true;
      const {data} = await api.post('/uploads/updateBlackList', {
        selected: this.selected,
        upload_id: 15,
      })
      if (data.success) {
        toastr['success']('Сохранено');
      }
      this.loadingBtn = false;
    },
    async getDrugs() {
      this.loading = true;
      const {data} = await api.index('/uploads/getDrugsForUpload?id=2')
      if (data.success) {
        this.records = _.orderBy(data.drugs, 'title');
        this.selected = data.blackList.reduce((acc, b) => {
          acc[b.object_id] = true;
          return acc;
        }, {})
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 4px;
}
</style>
